import home from './home.vue';
import taskcenter from './taskcenter.vue';
import MobileTaskCenter from './MobileTaskCenter.vue';
import eventsReport from './eventsReport.vue';
import map from './component/map.vue';
import videoConnection from './videoConnection.vue';
import videoCall from './videoCall.vue';
import MobileHotMap from './MobileHotMap.vue';
import MapView from './component/MapView.vue';

let views = {
    home,   // 任务反馈入口
    taskcenter,
    MobileTaskCenter,
    eventsReport,
    map,
    videoConnection,
    videoCall,
    MobileHotMap,
    MapView
};

export default views;